import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "dashboard-header" }
const _hoisted_2 = { class: "title-main" }
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = { class: "input-wr" }
const _hoisted_9 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_14 = { class: "input-wr" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = { class: "input-wr" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(`${$setup.form.firstName} ${$setup.form.lastName}`), 1)
    ]),
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.form.firstName.$error }]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
            type: "text",
            placeholder: "First Name"
          }, null, 2), [
            [_vModelText, $setup.form.firstName]
          ]),
          ($setup.v$.form.firstName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.form.firstName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Middle Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.middleName) = $event)),
            type: "text",
            placeholder: "Middle Name"
          }, null, 512), [
            [_vModelText, $setup.form.middleName]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.form.lastName.$error }]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.lastName) = $event)),
            type: "text",
            placeholder: "Last Name"
          }, null, 2), [
            [_vModelText, $setup.form.lastName]
          ]),
          ($setup.v$.form.lastName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.v$.form.lastName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Email", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.emailField.$error || $setup.emailError }]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.emailField) = $event)),
            onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.emailError = '')),
            type: "email",
            placeholder: "Email"
          }, null, 34), [
            [_vModelText, $setup.emailField]
          ]),
          ($setup.v$.emailField.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.emailField.$errors[0].$message), 1))
            : _createCommentVNode("", true),
          ($setup.emailError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.emailError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
          _createVNode($setup["Cleave"], {
            class: _normalizeClass(["input", { error: $setup.v$.form.phone.$error }]),
            modelValue: $setup.form.phone,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.phone) = $event)),
            options: $setup.phoneNumberOption($setup.form.phone),
            placeholder: "0412 345 678"
          }, null, 8, ["modelValue", "options", "class"]),
          ($setup.v$.form.phone.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Invalid phone"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Tier", -1)),
          _withDirectives(_createElementVNode("select", {
            class: _normalizeClass(["input", { error: $setup.v$.form.tier.$error }]),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.tier) = $event)),
            placeholder: "Tier"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values($setup.UserTier), (tier) => {
              return (_openBlock(), _createElementBlock("option", {
                key: tier,
                value: tier
              }, _toDisplayString(tier), 9, _hoisted_17))
            }), 128))
          ], 2), [
            [_vModelSelect, $setup.form.tier]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "button default outlined cancel-btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.router.go(-1))),
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.updateUser,
          type: "button"
        }, "Update")
      ])
    ])
  ], 64))
}